module.exports = __webpack_public_path__ + "static/quick-logo-4c936e62369be937b8da5250d5016975.jpg";